// Persist values to the signed-in user's `preferences` (JSON column) via
// `PATCH /users` (Users::RegistrationsController#update). Fire-and-forget:
// callers update the UI optimistically and ignore the response.

export function csrfToken(): string {
  if (typeof document === "undefined") return ""
  return (
    document
      .querySelector('meta[name="csrf-token"]')
      ?.getAttribute("content") ?? ""
  )
}

// Returns a promise that settles once the request completes, so callers that need
// the value persisted before acting (e.g. reloading to re-render in a new locale)
// can `await` it. Theme callers ignore the return value (fire-and-forget).
export function patchUser(user: Record<string, unknown>): Promise<void> {
  if (typeof fetch === "undefined") return Promise.resolve()
  return fetch("/users", {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "X-CSRF-Token": csrfToken(),
    },
    credentials: "same-origin",
    body: JSON.stringify({ user }),
  })
    .then(() => {})
    .catch(() => {})
}
